import type { LocationInput } from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import { createAction, props } from '@ngrx/store';

export const clearCurrentBuilding = createAction('[MY-BUILDING] Clear Current Building');

export const currentBuilding = createAction(
	'[MY-BUILDING] Current Building',
	props<{ building: LocationInput }>()
);

export const loadBuilding = createAction('[MY-BUILDING] Load currentBuilding');
